module.exports = __webpack_public_path__ + "d2cc942608527ea0ad87409a3dfee0fe.svg";